module.exports = __webpack_public_path__ + "img/blog_menu_pic1.caa34a3b.png";